import React from "react";
import { RaisedButton, FontIcon } from "material-ui";
import EditPaymentMethodOverlay from "../overlays/edit-payment-method.jsx";

class EditPaymentMethodButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false
    };
  }

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
    tenant: React.PropTypes.object,
    isLarge: React.PropTypes.bool
  };

  getStyles() {
    return {
      iconButton: {
        height: "100%",
        display: "inline-block",
        verticalAlign: -1,
        lineHeight: "36px",
        fontSize: 15
      }
    };
  }

  render() {
    let { passId, style, label, disabled } = this.props,
      styles = this.getStyles(),
      button = (
        <RaisedButton
          className="eventive__edit-payment-method-button__button"
          disabled={disabled}
          label={label}
          labelPosition="before"
          primary={true}
          onClick={() => this.setState({ open: true })}
        />
      );

    return (
      <div
        className="eventive__edit-payment-method-button__container"
        data-button-mode="pass"
      >
        {this.state.open ? (
          <EditPaymentMethodOverlay
            onCancel={() => this.setState({ open: false })}
            onComplete={() => this.setState({ open: false })}
          />
        ) : null}
        {button}
      </div>
    );
  }
}

export default EditPaymentMethodButton;



// WEBPACK FOOTER //
// ./src/app/components/partials/edit-payment-method-button.jsx